export const SELF_ITEM = { name: "Self", id: null };